import { render } from "./JobsKpis.vue?vue&type=template&id=c4e15b1c&scoped=true"
import script from "./JobsKpis.vue?vue&type=script&lang=js"
export * from "./JobsKpis.vue?vue&type=script&lang=js"

import "./JobsKpis.vue?vue&type=style&index=0&id=c4e15b1c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e15b1c"]])

export default __exports__